import createCommonModule from '@/common/store/modules/common';
import { DEFAULT_DOMAIN_PROJECT_NAME } from '@/common/constants/domains.constants';
import domainProjectModel from '@/common/store/modules/domains/createDomainProject';
import Vue from 'vue';
import useAuthStore from '@/common/store/pinia/auth';

const getDomainId = ({ rootState, rootGetters }) => rootState.routes.params.domainId || rootGetters.currentDomainId;

export default createCommonModule({
  namespaced: true,
  name: 'domainProjects',
  resource: store => Promise.resolve(`/api/v2/domains/${getDomainId(store)}/projects`),
  Model: domainProjectModel,
  pagingSupport: true,
  state: {
    /**
     * ProjectMember {ProjectId: {projectId, members: {userId,role}}
     */
    projectMembers: {}
  },
  getters: {
    getProjectMembersById: (state) => (projectId) => state.projectMembers[projectId],
    getDefaultProject: state => Object.values(state.itemsMap).find(project => project.name === DEFAULT_DOMAIN_PROJECT_NAME)
  },
  actions: ({ resource, Model }) => ({
    CREATE(store, payload = {}) {
      const { commit } = store;

      return resource(store)
        .then(resourceStr => this.$api.post(resourceStr, payload))
        .then((res) => {
          commit('CLEAR_ERRORS');

          const newItem = new Model(res.data);
          commit('CHANGE', { item: newItem, merge: false });

          const authStore = useAuthStore();
          return authStore.getUserProjects().then(() => res);
        })
        .catch((error) => {
          commit('SET_ERRORS', error);

          throw error;
        });
    },
    FETCH_PROJECT_WITH_MEMBERS({ dispatch }, payload = {}) {
      return dispatch('FETCH_ITEM', payload)
        .then(() => dispatch('FETCH_PROJECT_MEMBERS', { projectId: payload.id, options: payload.options }));
    },
    FETCH_PROJECTS_WITH_MEMBERS({ dispatch }, payload = {}) {
      return dispatch('FETCH_ITEMS', payload)
        .then(({ data }) => data.data
            .map(project => dispatch('FETCH_PROJECT_MEMBERS', { projectId: project.id, options: payload.options }))
        );
    },
    DELETE_ITEMS(store, items) {
      const { commit } = store;
      const uuids = items.map(item => item.id);
      return resource(store)
        .then(resourceStr => this.$api.delete(resourceStr, { uuids }))
        .then((res) => {
          commit('CLEAR_ERRORS');
          items.forEach(it => commit('REMOVE', it.id));

          if (Array.isArray(items) && items.length) {
            const authStore = useAuthStore();
            return authStore.getUserProjects()
              .then(() => res);
          }

          return res;
        })
        .catch((error) => {
          commit('SET_ERRORS', error);

          throw error;
        });
    },
    FETCH_PROJECT_MEMBERS(store, { projectId, options }) {
      const { commit } = store;

      return resource(store)
        .then(resourceStr => this.$api.get(`${resourceStr}/${projectId}/users`, {}, options))
        .then((res) => {
          const projectMembers = res.data.data;

          commit('SET_PROJECT_MEMBERS', {
            projectId,
            projectMembers
          });

          return res;
        })
        .catch((error) => {
          commit('SET_ERRORS', error);

          throw error;
        });
    },
  }),
  mutations: {
    SET_PROJECT_MEMBERS(state, { projectId, projectMembers }) {
      Vue.set(state.projectMembers, projectId, projectMembers);
    }
  }
});
